<template>
  <div class="formSet-page">
    <KeySet :column="column" :button="button" :columnOne="columnOne" :LanguageSet="2" :api="'itemsConfig'" :comDataId="dataId"
      :isStringTitle="isStringTitle" :routePath="routePath" @handleClickHandle="handleClickHandle"  @handleSelect="handleSelect"/>
    <el-dialog :title="title" :visible.sync="dialogVisible" width="50%" append-to-body :fullscreen="true">
      <languageSet v-if="title === '语言设置'" :dataIdFour="tableDataId" :typeFour="tableDataType"></languageSet>
      <codingSet v-if="title === '编码设置'" :codingSetData="codingSetData"></codingSet>
      <span slot="footer" class="dialog-footer" v-if="title !== '编码设置'">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { dataType, dataForm, formType, widthList, TriggerMode, numericType, doubleType, pleaseSelectARuleType } from "@/assets/js/table";
import { sheetsConfig } from "@/api/sysTem/index";
import { dictFind } from "@/api/dict";
import { getzdlist } from '@/api/sysTem/reportModule';
import { findRoleList } from "@/api/sysTem/roleAdmin";
import KeySet from "../com/index";
import languageSet from '../LanguageSet/index.vue'
import codingSet from '../codingSet/index.vue'
export default {
  name: "formSet-page",
  extends: { KeySet },
  props: {
    dataIdTwo: {
      type: String,
      default: ''
    },
    isString: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // button: [{ key: "add", label: this.$t('FormOfSet.add') }],
      button: [],
      column: [
        { prop: "showOrder", label: this.$t('FormOfSet.fieldOrder'), fixed: true ,alignType: 2},
        { prop: "itemName", label: this.$t('FormOfSet.name'), isReadOnly: true, fixed: true,alignType: 2 },
        { prop: "itemShowName", label: this.$t('FormOfSet.showName'), fixed: true ,alignType: 2},
        { prop: "defaultValue", label: this.$t('FormOfSet.defaultValue'),extAttr:'formAddDefaultValue',alignType: 2 },
        { prop: 'expressionDecimalDigit', label: this.$t('FormOfSet.expressionDecimalDigit'), alignType: 2 },
        { prop: "dataType", label: this.$t('FormOfSet.dataType'), isReadOnly: true, type: "select", list: dataType(), alignType: 2 },
        { prop: "remark", label: this.$t('FormOfSet.remark') },
        { prop: "sheetId", label: this.$t('FormOfSet.sheet'), type: "select",
          list: () => { return sheetsConfig({ method: "get", reqInfo: { formId: this._id }}).then((res) => res?.map((item) => ({ value: item.id, label: item.sheetName })))} },
        { prop: "mtype", label: this.$t('FormOfSet.clauseTemplete'), type: "select",
          list: () =>{ return getzdlist({ name: "条款类型" }).then((res) => res.map((item)=>({ value: item.itemValue, label: item.itemValue })))} },
        { prop: "stretchTile", label: this.$t('FormOfSet.widthType'), type: "select", list: widthList() },
        { prop: "approveParam", label: this.$t('FormOfSet.approveParam'), type: "switch" ,alignType: 2},
        { prop: "isEditableUnderApproval", label: this.$t("FormOfSet.approveChange"), type: "switch", alignType: 2 },
        { prop: "isUpdateKeyOnImport", label: this.$t('listOfSet.isUpdateKeyOnImport'), type: "switch" },
        { prop: "showForRoles", label: this.$t('FormOfSet.isShow'), type: "select", multiple: true, collapseTags: true,
          optionLabel: "roleName", optionValue: "roleId", valueKey: "roleId", list: []},
        { prop: "expression", label: this.$t('FormOfSet.expression'), type: "textarea" },
        { prop: "dataItemField", label: '字典关联字段' },
      ],
      columnOne: [
        { prop: "editType", label: this.$t('FormOfSet.editType'), type: "select", list: formType(), alignType: 2 },
        { prop: "readOnlyRoles", label: this.$t('FormOfSet.isReadOnly'), type: "select", multiple: true,
          collapseTags: true, optionLabel: "roleName", optionValue: "roleId", valueKey: "roleId", list: [] },
        { prop: "dicId", label: this.$t('FormOfSet.dataDict'), type: "select", filterable:true, alignType: 2,
          list: () =>{ return dictFind().then((res) => res.map((item)=>({ value: item.id, label: item.dicName })))} },
        { prop: "isMustFill", label: this.$t('FormOfSet.isMustFill'), type: "switch" ,alignType: 2 },
        { prop: "isMustFillAgree", label: this.$t('FormOfSet.isMustFillAgree'), type: "switch" ,alignType: 2 },

        { prop: "ruleLength", label: this.$t('FormOfSet.inputLength'), alignType: 2 },
        { prop: "ruleMessageList", label: this.$t('FormOfSet.promptContent'), type:'buttons' },
        { prop: "ruleType", label: this.$t('FormOfSet.numericType'), list: numericType(), type: "select" },
        { prop: "ruleFormat", label: this.$t('FormOfSet.format'), type: "select", list: doubleType() },
        { prop: "ruleMethod", label: this.$t('FormOfSet.triggerMode'), type: "select", list: TriggerMode(), alignType: 2  },
        { prop: "ruleValidate", label: this.$t('FormOfSet.pleaseSelectARuleType'), type: "select", list: pleaseSelectARuleType(), selectDialog: true },
        { prop: "onlySelected", label: this.$t('FormOfSet.isManualEntry'), type: "switch" ,alignType: 2 },
      ],
      dataId: '',
      routePath: '/system/formSet',
      dialogVisible: false,
      title: '',
      tableDataId: '',
      tableDataType: '',
      codingSetData: {},
      isStringTitle: null
    };
  },
  computed: {
    _id() {
      return this.$route.query.id || this.dataId;
    },
  },

  watch: {
    dataIdTwo: {
      handler(newVal, oldVal) {
        this.dataId = newVal
      }, deep: true, immediate: true
    },
    isString: {
      handler(newVal, oldVal) {
        this.isStringTitle = newVal
      }, deep: true, immediate: true
    }
  },
  components: { KeySet, languageSet, codingSet },

  async beforeCreate() {
    const mm = await findRoleList().then((res) =>
      res.result.map((item) => ({
        ...item,
        roleId: item.id,
      }))
    );
    this.columnOne.filter((item) =>
      item.prop === "readOnlyRoles"
    ).forEach((v) => (v.list = mm));
    this.column.filter((item) =>
      item.prop === "showForRoles"
    ).forEach((v) => (v.list = mm));
  },

  methods: {
    handleSelect(value, item, it) {

    },
    handleClickHandle(title, row, LanguageSet) {
      switch (title) {
        case "Language":
          this.title = '语言设置'
          this.dialogVisible = true
          this.tableDataId = row.id
          this.tableDataType = LanguageSet
          break;
        case 'coding':
          this.title = '编码设置'
          this.dialogVisible = true
          this.codingSetData = row
          break;
      }
    }
  }
};
</script>
<style scoped lang="scss">
.formSet-page {
  height: 100%;
}
</style>
